define('components/factory/models/ViewerModel', [

], function() {

    var ViewerModel = Backbone.Model.extend({
        defaults: {
            viewId: "viewer-id",            // Classic default viewId
            swiperType: 'fader',            // 'fader' || 'slideshow'
            skinClass: 'grey',             // Skin class of the viewer ( white || grey || black )
            fillOrFitOptions: {             // FillOrFit plugin params ( Cf fillorfit )
                method: 'fit',
                verticalAlign: 'center',
                horizontalAlign: 'center'
            },
            currentSlide: 0,
            images: [],                     // List of images
            title: null,                    // Title of the view. If empty -> hidden
            legend: null,                   // Legend of the view. If empty -> hidden
            showThumbsSwiper: false,        // Show / Hide Aside Thumbs Slideshow
            showPagination: true,           // Show / Hide Aside Thumbs Slideshow
            thumbs: [],                     // List of thumbs images ( each thumb must corresponds to each image )
            isReady: false                  // Classic isReady
        }
    });

    return ViewerModel;
});
